
// SVG Icon: circle-empty
export default { id: "terriajs-circle-empty" };
export const id = "terriajs-circle-empty";
export const name = "circle-empty";
